import React, { useContext, useState, useEffect } from "react";

import Paper from "@material-ui/core/Paper";
import Typography from "@material-ui/core/Typography";
// import {  Button, Grid } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { useTheme } from "@material-ui/core/styles";
import { IconButton } from "@mui/material";
import { Groups, SaveAlt } from "@mui/icons-material";

import CallIcon from "@material-ui/icons/Call";
import RecordVoiceOverIcon from "@material-ui/icons/RecordVoiceOver";
import GroupAddIcon from "@material-ui/icons/GroupAdd";
import HourglassEmptyIcon from "@material-ui/icons/HourglassEmpty";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import FilterListIcon from "@material-ui/icons/FilterList";
import ClearIcon from "@material-ui/icons/Clear";
import SendIcon from "@material-ui/icons/Send";
import MessageIcon from "@material-ui/icons/Message";
import AccessAlarmIcon from "@material-ui/icons/AccessAlarm";
import TimerIcon from "@material-ui/icons/Timer";
import AccountTreeIcon from "@material-ui/icons/AccountTree";
import MailOutlineIcon from "@material-ui/icons/MailOutline";
import PhotoCameraIcon from "@material-ui/icons/PhotoCamera";
import GroupIcon from "@material-ui/icons/Group";
import SupervisedUserCircleIcon from "@material-ui/icons/SupervisedUserCircle";
import WidgetsIcon from "@material-ui/icons/Widgets";
import ChatBubbleOutlineIcon from "@material-ui/icons/ChatBubbleOutline";
import * as XLSX from "xlsx";
import CheckCircleOutlineIcon from "@material-ui/icons/RecordVoiceOver";
import ErrorOutlineIcon from "@material-ui/icons/RecordVoiceOver";

import { grey, blue } from "@material-ui/core/colors";
import { toast } from "react-toastify";

import MainContainer from "../../components/MainContainer";
import TabPanel from "../../components/TabPanel";
import TableAttendantsStatus from "../../components/Dashboard/TableAttendantsStatus";
import { isArray } from "lodash";

import { AuthContext } from "../../context/Auth/AuthContext";
import { socketManager } from "../../context/Socket/SocketContext";

import useDashboard from "../../hooks/useDashboard";
import useContacts from "../../hooks/useContacts";
import useMessages from "../../hooks/useMessages";
import { ChatsUser } from "./ChartsUser";

import Filters from "./Filters";
import { isEmpty } from "lodash";
import moment from "moment";
import { ChartsDate } from "./ChartsDate";
import { getStandardButtonStyles } from "../../styles/standardButtons";
import {
  Avatar,
  Button,
  Card,
  CardContent,
  Container,
  Stack,
  SvgIcon,
  Tab,
  Tabs,
  LinearProgress,
  Box,
} from "@mui/material";
import { i18n } from "../../translate/i18n";
import Grid2 from "@mui/material/Unstable_Grid2/Grid2";
import ForbiddenPage from "../../components/ForbiddenPage";
import { ArrowDownward, ArrowUpward } from "@material-ui/icons";
import PageHelpGuide from "../../components/PageHelpGuide";
import { DASHBOARD_HELP_DATA } from "../../constants/pageHelp/dashboardHelp";

const useStyles = makeStyles((theme) => ({
  ...getStandardButtonStyles(theme),
  overline: {
    fontSize: "0.9rem",
    fontWeight: 700,
    color: theme.palette.text.secondary,
    letterSpacing: "0.5px",
    lineHeight: 2.5,
    textTransform: "uppercase",
    fontFamily: "'Plus Jakarta Sans', sans-serif'",
  },
  h4: {
    fontFamily: "'Plus Jakarta Sans', sans-serif'",
    fontWeight: 500,
    fontSize: "2rem",
    lineHeight: 1,
    color: theme.palette.text.primary,
  },
  selected: {},
  tab: {
    minWidth: "auto",
    width: "auto",
    padding: theme.spacing(0.5, 1),
    borderRadius: 8,
    transition: "0.3s",
    borderWidth: "1px",
    borderStyle: "solid",
    marginRight: theme.spacing(0.5),
    marginLeft: theme.spacing(0.5),

    [theme.breakpoints.down("lg")]: {
      fontSize: "0.9rem",
      padding: theme.spacing(0.4, 0.8),
      marginRight: theme.spacing(0.4),
      marginLeft: theme.spacing(0.4),
    },
    [theme.breakpoints.down("md")]: {
      fontSize: "0.8rem",
      padding: theme.spacing(0.3, 0.6),
      marginRight: theme.spacing(0.3),
      marginLeft: theme.spacing(0.3),
    },
    "&:hover": {
      backgroundColor: "rgba(6, 81, 131, 0.3)",
    },
    "&$selected": {
      color: theme.palette.primary.contrastText,
      backgroundColor: theme.palette.primary.main,
    },
  },
  tabIndicator: {
    borderWidth: "2px",
    borderStyle: "solid",
    height: 6,
    bottom: 0,
    color:
      theme.palette.mode === "light"
        ? theme.palette.primary.main
        : theme.palette.primary.contrastText,
  },
  container: {
    paddingTop: theme.spacing(1),
    paddingBottom: theme.spacing(1),
  },
  nps: {
    paddingTop: theme.spacing(1),
    paddingBottom: theme.padding,
  },
  fixedHeightPaper: {
    padding: theme.spacing(2),
    display: "flex",
    flexDirection: "column",
    height: 240,
    overflowY: "auto",
    ...theme.scrollbarStyles,
  },
  cardAvatar: {
    fontSize: "55px",
    color: theme.palette.text.primary,
    backgroundColor: theme.palette.background.paper,
    width: theme.spacing(7),
    height: theme.spacing(7),
  },
  cardTitle: {
    fontSize: "18px",
    color: theme.palette.primary.main,
  },
  cardSubtitle: {
    color: theme.palette.text.secondary,
    fontSize: "14px",
  },
  alignRight: {
    textAlign: "right",
  },
  fullWidth: {
    width: "100%",
  },
  selectContainer: {
    width: "100%",
    textAlign: "left",
  },
  iframeDashboard: {
    width: "100%",
    height: "calc(100vh - 64px)",
    border: "none",
  },
  customFixedHeightPaperLg: {
    padding: theme.spacing(2),
    display: "flex",
    overflow: "auto",
    flexDirection: "column",
    height: "100%",
  },
  sectionTitle: {
    fontSize: "1.5rem",
    fontWeight: 700,
    color: theme.palette.primary.main,
    marginBottom: theme.spacing(2),
  },
  mainPaper: {
    flex: 1,
    overflow: "hidden",
    backgroundColor: theme.palette.type === "dark" ? "#2A2D32 !important" : theme.palette.background.paper,
    borderRadius: 16,
    display: "flex",
    flexDirection: "column",
    padding: theme.spacing(1),
  },
  scrollArea: {
    ...theme.scrollbarStyles,
    overflowY: "auto",
    overflowX: "hidden",
    flex: 1,
    paddingRight: theme.spacing(1),
  },
  paper: {
    padding: theme.spacing(2),
    borderRadius: 12,
    backgroundColor: theme.palette.type === "dark" ? "#2A2D32" : theme.palette.background.paper,
  },
  tableWrapper: {
    padding: theme.spacing(1),
    borderRadius: "10px",
    backgroundColor: theme.palette.type === "dark" ? "#2A2D32" : theme.palette.background.paper,
    overflow: "hidden",
  },
  barContainer: {
    display: "flex",
    alignItems: "center",
    marginBottom: theme.spacing(1),
  },
  progressBar: {
    flex: 1,
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
    borderRadius: 5,
    height: 10,
  },
  progressLabel: {
    minWidth: 50,
    textAlign: "right",
    fontWeight: 500,
    color: theme.palette.mode === "light" ? theme.palette.text.secondary : theme.palette.text.primary,
  },
  infoCard: {
    padding: theme.spacing(2),
    textAlign: "center",
    borderRadius: 12,
    backgroundColor: theme.palette.type === "dark" ? "#2A2D32" : theme.palette.background.paper,
    marginBottom: theme.spacing(2),
  },
  infoIcon: {
    fontSize: "2rem",
    color: theme.palette.primary.main,
    marginBottom: theme.spacing(1),
  },
  mainContainerPadding: {
    paddingLeft: "20px !important",
    paddingRight: "20px !important",
    [theme.breakpoints.down('sm')]: {
      paddingLeft: "16px !important",
      paddingRight: "16px !important",
    },
  },
  barGreen: {
    backgroundColor: "#2EA85A !important",
  },
  barYellow: {
    backgroundColor: "#F7EC2C !important",
  },
  barRed: {
    backgroundColor: "#F73A2C !important",
  },
  barScore: {
    backgroundColor: theme.palette.type === "dark" ? "#FFF !important" : `${theme.palette.primary.main} !important`,
  },
}));

const Dashboard = () => {
  const theme = useTheme();
  const classes = useStyles();
  const [counters, setCounters] = useState({});
  const [attendants, setAttendants] = useState([]);
  const [filterType, setFilterType] = useState(1);
  const [period, setPeriod] = useState(0);
  const [dateFrom, setDateFrom] = useState(
    `${new Date().getFullYear()}-${String(new Date().getMonth() + 1).padStart(2, '0')}-01`
  );
  const [dateTo, setDateTo] = useState(
    `${new Date().getFullYear()}-${String(new Date().getMonth() + 1).padStart(2, '0')}-${String(new Date().getDate()).padStart(2, '0')}`
  );
  const [loading, setLoading] = useState(false);
  const { find } = useDashboard();

  //FILTROS NPS
  const [tab, setTab] = useState("Indicadores");
  const [selectedUsers, setSelectedUsers] = useState([]);
  const [selectedQueues, setSelectedQueues] = useState([]);

  let newDate = new Date();
  let date = newDate.getDate();
  let month = newDate.getMonth() + 1;
  let year = newDate.getFullYear();
  let nowIni = `${year}-${month < 10 ? `0${month}` : `${month}`}-01`;

  let now = `${year}-${month < 10 ? `0${month}` : `${month}`
    }-${date < 10 ? `0${date}` : `${date}`}`;

  const [showFilter, setShowFilter] = useState(false);
  const [dateStartTicket, setDateStartTicket] = useState(nowIni);
  const [dateEndTicket, setDateEndTicket] = useState(now);
  const [queueTicket, setQueueTicket] = useState(false);
  const [fetchDataFilter, setFetchDataFilter] = useState(false);

  const { user, socket: authSocket } = useContext(AuthContext);
  const socketTimeoutRef = React.useRef(null);

  const exportarGridParaExcel = () => {
    const ws = XLSX.utils.table_to_sheet(
      document.getElementById("grid-attendants")
    );
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "RelatorioDeAtendentes");
    XLSX.writeFile(wb, "relatorio-de-atendentes.xlsx");
  };

  var userQueueIds = [];

  if (user.queues && user.queues.length > 0) {
    userQueueIds = user.queues.map((q) => q.id);
  }

  useEffect(() => {
    let isMounted = true;

    async function firstLoad() {
      if (isMounted) {
        // console.log('Executando firstLoad...');
        await fetchData();
      }
    }

    const timeoutId = setTimeout(() => {
      firstLoad();
    }, 500);

    return () => {
      isMounted = false;
      clearTimeout(timeoutId);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [fetchDataFilter]);

  useEffect(() => {
    const socket = authSocket || socketManager.GetSocket();
    const companyId = user?.companyId;

    if (!socket || !companyId) return;

    const onRealtimeEvent = () => {
      if (socketTimeoutRef.current) {
        clearTimeout(socketTimeoutRef.current);
      }
      socketTimeoutRef.current = setTimeout(() => {
        fetchData(true);
      }, 1000);
    };

    const eventAppMessage = `company-${companyId}-appMessage`;
    const eventTicket = `company-${companyId}-ticket`;
    const eventContact = `company-${companyId}-contact`;
    const eventConsumption = `company-${companyId}-consumption`;

    socket.on(eventAppMessage, onRealtimeEvent);
    socket.on(eventTicket, onRealtimeEvent);
    socket.on(eventContact, onRealtimeEvent);
    socket.on(eventConsumption, onRealtimeEvent);

    // Polling suave de respaldo cada 60 segundos
    const pollInterval = setInterval(() => {
      fetchData(true);
    }, 60000);

    return () => {
      if (socketTimeoutRef.current) {
        clearTimeout(socketTimeoutRef.current);
      }
      clearInterval(pollInterval);
      socket.off(eventAppMessage, onRealtimeEvent);
      socket.off(eventTicket, onRealtimeEvent);
      socket.off(eventContact, onRealtimeEvent);
      socket.off(eventConsumption, onRealtimeEvent);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user?.companyId, period, dateStartTicket, dateEndTicket]);

  async function fetchData(isSilent = false) {
    if (!isSilent) {
      setLoading(true);
    }
    // console.log('Iniciando fetchData...');

    let params = {};

    // Construir parâmetros de filtro
    if (period > 0) {
      params = {
        days: period,
      };
    } else {
      // Se não há período específico, usar as datas (já en formato YYYY-MM-DD)
      if (!isEmpty(dateStartTicket)) {
        params = {
          ...params,
          date_from: dateStartTicket,
        };
      }

      if (!isEmpty(dateEndTicket)) {
        params = {
          ...params,
          date_to: dateEndTicket,
        };
      }
    }

    // Se nenhum parâmetro foi definido, usar período padrão de 30 dias
    if (Object.keys(params).length === 0) {
      // console.log('Nenhum filtro definido, usando 30 dias como padrão');
      params = { days: 30 };
    }

    // console.log('Parâmetros finais para busca:', params);

    try {
      const data = await find(params);
      // console.log('Dados recebidos no componente:', data);

      // Garantir que counters sempre tenha valores válidos
      const safeCounters = data.counters || {};

      setCounters(safeCounters);

      if (isArray(data.attendants)) {
        setAttendants(data.attendants);
      } else {
        // console.warn('Attendants não é um array:', data.attendants);
        setAttendants([]);
      }
    } catch (error) {
      console.error('Erro ao buscar dados:', error);
      if (!isSilent) {
        toast.error(i18n.t("dashboard.error.fetchData"));

        // Definir valores padrão em caso de erro
        setCounters({
          avgSupportTime: 0,
          avgWaitTime: 0,
          supportFinished: 0,
          supportHappening: 0,
          supportPending: 0,
          supportGroups: 0,
          leads: 0,
          activeTickets: 0,
          passiveTickets: 0,
          tickets: 0,
          waitRating: 0,
          withoutRating: 0,
          withRating: 0,
          percRating: 0,
          npsPromotersPerc: 0,
          npsPassivePerc: 0,
          npsDetractorsPerc: 0,
          npsScore: 0
        });
        setAttendants([]);
      }
    } finally {
      if (!isSilent) {
        setLoading(false);
      }
    }
  }

  const handleSelectedUsers = (selecteds) => {
    const users = selecteds.map((t) => t.id);
    setSelectedUsers(users);
  };

  const handleChangeTab = (e, newValue) => {
    setTab(newValue);
  };

  function formatTime(minutes) {
    if (minutes === undefined || minutes === null || isNaN(minutes)) return "00h 00m 00s";
    const totalSeconds = Math.round(Number(minutes) * 60);
    const h = Math.floor(totalSeconds / 3600);
    const m = Math.floor((totalSeconds % 3600) / 60);
    const s = totalSeconds % 60;
    return `${String(h).padStart(2, "0")}h ${String(m).padStart(2, "0")}m ${String(s).padStart(2, "0")}s`;
  }

  const GetUsers = () => {
    let count;
    let userOnline = 0;
    attendants.forEach((user) => {
      if (user.online === true) {
        userOnline = userOnline + 1;
      }
    });
    count = userOnline === 0 ? 0 : userOnline;
    return count;
  };

  const GetContacts = (all) => {
    let props = {};
    if (all) {
      props = {};
    } else {
      props = {
        dateStart: dateStartTicket,
        dateEnd: dateEndTicket,
      };
    }
    const { count } = useContacts(props);
    return count;
  };

  const GetMessages = (all, fromMe) => {
    let props = {};
    if (all) {
      if (fromMe) {
        props = {
          fromMe: true,
        };
      } else {
        props = {
          fromMe: false,
        };
      }
    } else {
      if (fromMe) {
        props = {
          fromMe: true,
          dateStart: dateStartTicket,
          dateEnd: dateEndTicket,
        };
      } else {
        props = {
          fromMe: false,
          dateStart: dateStartTicket,
          dateEnd: dateEndTicket,
        };
      }
    }
    const { count } = useMessages(props);
    return count;
  };

  function toggleShowFilter() {
    setShowFilter(!showFilter);
  }

  return (
    <>
      {user.profile === "user" && user.showDashboard === "disabled" ? (
        <ForbiddenPage />
      ) : (
        <MainContainer>
          <Paper
            className={classes.mainPaper}
            variant="outlined"
          >
            <div className={classes.scrollArea}>
              <Container maxWidth={false} className={`${classes.container} ${classes.mainContainerPadding}`} style={{ paddingBottom: '20px', maxWidth: '100%', overflowX: 'hidden' }}>
                <Grid2 container spacing={2} className={classes.container} style={{ margin: 0, width: '100%' }}>
                {/* CABECERA SUPERIOR: SONAR DE AYUDA Y FILTROS */}
                <Grid2 xs={12} container justifyContent="space-between" alignItems="center" style={{ marginTop: '4px', marginBottom: '8px' }}>
                  <Box display="flex" alignItems="center" style={{ gap: '14px' }}>
                    <PageHelpGuide
                      helpData={DASHBOARD_HELP_DATA}
                      tooltipText="Guía y Ayuda del Dashboard (Haz clic para ver)"
                    />
                    <Typography
                      variant="h5"
                      style={{
                        fontWeight: 700,
                        color: theme.palette.type === "dark" ? "#FFF" : theme.palette.primary.main,
                        letterSpacing: "-0.5px",
                      }}
                    >
                      Dashboard
                    </Typography>
                  </Box>

                  <Button
                    size="small"
                    variant="outlined"
                    className={classes.applyButton}
                    onClick={toggleShowFilter}
                    startIcon={!showFilter ? <FilterListIcon style={{ fontSize: 18 }} /> : <ClearIcon style={{ fontSize: 18 }} />}
                  >
                    {showFilter ? i18n.t("dashboard.filters.hide") : i18n.t("dashboard.filters.show")}
                  </Button>
                </Grid2>

                {showFilter && (
                  <Grid2 xs={12} style={{ marginBottom: "20px" }}>
                    <Filters
                      classes={classes}
                      setDateStartTicket={setDateStartTicket}
                      setDateEndTicket={setDateEndTicket}
                      dateStartTicket={dateStartTicket}
                      dateEndTicket={dateEndTicket}
                      setQueueTicket={setQueueTicket}
                      queueTicket={queueTicket}
                      fetchData={setFetchDataFilter}
                    />
                  </Grid2>
                )}

                {/* Indicadores Gerais */}
                <Grid2 xs={12} style={{ marginTop: '20px', paddingLeft: '4px' }}>
                  <Typography variant="h5" style={{ marginBottom: '10px', color: theme.palette.type === "dark" ? "#FFF" : theme.palette.primary.main }}>{i18n.t("dashboard.tabs.indicators")}</Typography>
                </Grid2>
                {[
                  { label: i18n.t("dashboard.cards.inAttendance"), value: counters.supportHappening || 0, icon: <CallIcon style={{ color: "#01BBAC", fontSize: "2.5rem", filter: "drop-shadow(0 0 6px rgba(1, 187, 172, 0.6))" }} /> },
                  { label: i18n.t("dashboard.cards.waiting"), value: counters.supportPending || 0, icon: <HourglassEmptyIcon style={{ color: "#47606e", fontSize: "2.5rem", filter: "drop-shadow(0 0 6px rgba(71, 96, 110, 0.6))" }} /> },
                  { label: i18n.t("dashboard.cards.finalized"), value: counters.supportFinished || 0, icon: <CheckCircleIcon style={{ color: "#5704c2", fontSize: "2.5rem", filter: "drop-shadow(0 0 6px rgba(87, 4, 194, 0.6))" }} /> },
                  { label: i18n.t("dashboard.cards.groups"), value: counters.supportGroups || 0, icon: <GroupAddIcon style={{ color: "#01BBAC", fontSize: "2.5rem", filter: "drop-shadow(0 0 6px rgba(1, 187, 172, 0.6))" }} /> },
                  { label: i18n.t("dashboard.cards.activeAttendants"), value: `${counters.supportAttendantsActive || 0}/${counters.supportAttendants || 0}`, icon: <RecordVoiceOverIcon style={{ color: "#805753", fontSize: "2.5rem", filter: "drop-shadow(0 0 6px rgba(128, 87, 83, 0.6))" }} /> },
                  { label: i18n.t("dashboard.cards.planContacts"), value: `${counters.totalContacts || 0}/${counters.maxContacts || 0}`, icon: <GroupAddIcon style={{ color: "#bda800", fontSize: "2.5rem", filter: "drop-shadow(0 0 6px rgba(189, 168, 0, 0.6))" }} /> },
                  { label: i18n.t("dashboard.cards.totalReceivedMessages"), value: counters.messagesReceived || 0, icon: <MessageIcon style={{ color: "#6e6e47", fontSize: "2.5rem", filter: "drop-shadow(0 0 6px rgba(110, 110, 71, 0.6))" }} /> },
                  { label: i18n.t("dashboard.cards.totalSentMessages"), value: counters.messagesSent || 0, icon: <SendIcon style={{ color: "#325c34", fontSize: "2.5rem", filter: "drop-shadow(0 0 6px rgba(50, 92, 52, 0.6))" }} /> },
                  { label: i18n.t("dashboard.cards.averageServiceTime"), value: formatTime(counters.avgSupportTime) || "00h 00m 00s", icon: <AccessAlarmIcon style={{ color: "#bda800", fontSize: "2.5rem", filter: "drop-shadow(0 0 6px rgba(189, 168, 0, 0.6))" }} /> },
                  { label: i18n.t("dashboard.cards.averageWaitingTime"), value: formatTime(counters.avgWaitTime) || "00h 00m 00s", icon: <TimerIcon style={{ color: "#8a2c40", fontSize: "2.5rem", filter: "drop-shadow(0 0 6px rgba(138, 44, 64, 0.6))" }} /> },
                  { label: i18n.t("dashboard.cards.activeTickets"), value: counters.activeTickets || 0, icon: <ArrowUpward style={{ color: "#f44336", fontSize: "2.5rem", filter: "drop-shadow(0 0 6px rgba(244, 67, 54, 0.6))" }} /> },
                  { label: i18n.t("dashboard.cards.passiveTickets"), value: counters.passiveTickets || 0, icon: <ArrowDownward style={{ color: "#4caf50", fontSize: "2.5rem", filter: "drop-shadow(0 0 6px rgba(76, 175, 80, 0.6))" }} /> },
                ].map((indicator, index) => (
                  <Grid2 xs={12} sm={6} md={4} lg={3} key={index}>
                    <Paper className={classes.paper} variant="outlined">
                      <Box display="flex" alignItems="center">
                        {indicator.icon}
                        <Box ml={2}>
                          <Typography variant="h6">{indicator.value}</Typography>
                          <Typography variant="body2">{indicator.label}</Typography>
                        </Box>
                      </Box>
                    </Paper>
                  </Grid2>
                ))}

                

                {/* Consumo del Plan */}
                <Grid2 xs={12} style={{ marginTop: '30px', paddingLeft: '4px' }}>
                  <Typography variant="h5" style={{ marginBottom: '10px', color: theme.palette.type === "dark" ? "#FFF" : theme.palette.primary.main }}>{i18n.t("dashboard.sections.planUsage")}</Typography>
                </Grid2>
                {[
                  { label: i18n.t("dashboard.cards.contacts"), value: `${counters.totalContacts || 0} / ${counters.maxContacts <= 0 ? i18n.t("dashboard.cards.unlimited") : (counters.maxContacts || 0)}`, icon: <GroupAddIcon style={{ color: "#bda800", fontSize: "2.5rem", filter: "drop-shadow(0 0 6px rgba(189, 168, 0, 0.6))" }} /> },
                  { label: i18n.t("dashboard.cards.brands"), value: `${counters.usedBrands || 0} / ${counters.maxBrands || 0}`, icon: <CheckCircleIcon style={{ color: "#01BBAC", fontSize: "2.5rem", filter: "drop-shadow(0 0 6px rgba(1, 187, 172, 0.6))" }} /> },
                  { label: i18n.t("dashboard.cards.funnels"), value: `${counters.usedFunnels || 0} / ${counters.maxFunnels || 0}`, icon: <FilterListIcon style={{ color: "#5704c2", fontSize: "2.5rem", filter: "drop-shadow(0 0 6px rgba(87, 4, 194, 0.6))" }} /> },
                  { label: "WhatsApp QR", value: `${counters.usedConnQr || 0} / ${counters.maxConnQr || 0}`, icon: <CallIcon style={{ color: "#4caf50", fontSize: "2.5rem", filter: "drop-shadow(0 0 6px rgba(76, 175, 80, 0.6))" }} /> },
                  { label: "WhatsApp API", value: `${counters.usedConnApi || 0} / ${counters.maxConnApi || 0}`, icon: <CallIcon style={{ color: "#01BBAC", fontSize: "2.5rem", filter: "drop-shadow(0 0 6px rgba(1, 187, 172, 0.6))" }} /> },
                  { label: "Instagram", value: `${counters.usedConnIg || 0} / ${counters.maxConnIg || 0}`, icon: <MessageIcon style={{ color: "#E1306C", fontSize: "2.5rem", filter: "drop-shadow(0 0 6px rgba(225, 48, 108, 0.6))" }} /> },
                  { label: "Messenger", value: `${counters.usedConnMsg || 0} / ${counters.maxConnMsg || 0}`, icon: <MessageIcon style={{ color: "#0084FF", fontSize: "2.5rem", filter: "drop-shadow(0 0 6px rgba(0, 132, 255, 0.6))" }} /> },
                  { label: "Telegram", value: `${counters.usedConnTelegram || 0} / ${counters.maxConnTelegram || 0}`, icon: <SendIcon style={{ color: "#0088cc", fontSize: "2.5rem", filter: "drop-shadow(0 0 6px rgba(0, 136, 204, 0.6))" }} /> },
                  { label: i18n.t("dashboard.cards.emails"), value: `${counters.usedEmails || 0} / ${counters.maxEmails || 1}`, icon: <MailOutlineIcon style={{ color: "#795548", fontSize: "2.5rem", filter: "drop-shadow(0 0 6px rgba(121, 85, 72, 0.6))" }} /> },
                  { label: i18n.t("dashboard.cards.flows"), value: `${counters.usedFlows || 0} / ${counters.maxFlows <= 0 ? i18n.t("dashboard.cards.unlimited") : counters.maxFlows}`, icon: <AccountTreeIcon style={{ color: "#009688", fontSize: "2.5rem", filter: "drop-shadow(0 0 6px rgba(0, 150, 136, 0.6))" }} /> },
                  { label: i18n.t("dashboard.cards.statusPosts"), value: `${counters.usedStatusPosts || 0} / ${counters.maxStatusPosts === -1 ? i18n.t("dashboard.cards.unlimited") : (counters.maxStatusPosts || 0)}`, icon: <PhotoCameraIcon style={{ color: "#4caf50", fontSize: "2.5rem", filter: "drop-shadow(0 0 6px rgba(76, 175, 80, 0.6))" }} /> },
                  { label: i18n.t("dashboard.cards.groupPosts"), value: `${counters.usedGroupPosts || 0} / ${counters.maxGroupPosts === -1 ? i18n.t("dashboard.cards.unlimited") : (counters.maxGroupPosts || 0)}`, icon: <GroupIcon style={{ color: "#3f51b5", fontSize: "2.5rem", filter: "drop-shadow(0 0 6px rgba(63, 81, 181, 0.6))" }} /> },
                  { label: i18n.t("dashboard.cards.communityPosts"), value: `${counters.usedCommunityPosts || 0} / ${counters.maxCommunityPosts === -1 ? i18n.t("dashboard.cards.unlimited") : (counters.maxCommunityPosts || 0)}`, icon: <SupervisedUserCircleIcon style={{ color: "#673ab7", fontSize: "2.5rem", filter: "drop-shadow(0 0 6px rgba(103, 58, 183, 0.6))" }} /> },
                  { label: i18n.t("dashboard.cards.webWidgets"), value: `${counters.usedWebWidgets || 0} / ${counters.maxWebWidgets === -1 ? i18n.t("dashboard.cards.unlimited") : (counters.maxWebWidgets || 0)}`, icon: <WidgetsIcon style={{ color: "#ff9800", fontSize: "2.5rem", filter: "drop-shadow(0 0 6px rgba(255, 152, 0, 0.6))" }} /> },
                  { label: i18n.t("dashboard.cards.messagesMonth"), value: `${counters.usedMessagesMonth || 0} / ${counters.maxMessagesMonth <= 0 ? i18n.t("dashboard.cards.unlimited") : counters.maxMessagesMonth}`, icon: <ChatBubbleOutlineIcon style={{ color: "#00bcd4", fontSize: "2.5rem", filter: "drop-shadow(0 0 6px rgba(0, 188, 212, 0.6))" }} /> },
                ].map((indicator, index) => (
                  <Grid2 xs={12} sm={6} md={4} lg={3} key={index}>
                    <Paper className={classes.paper} variant="outlined">
                      <Box display="flex" alignItems="center">
                        {indicator.icon}
                        <Box ml={2}>
                          <Typography variant="h6">{indicator.value}</Typography>
                          <Typography variant="body2">{indicator.label}</Typography>
                        </Box>
                      </Box>
                    </Paper>
                  </Grid2>
                ))}

                {/* Pesquisa de Satisfação (NPS) */}
                <Grid2 xs={12} style={{ marginTop: '40px', paddingLeft: '4px' }}>
                  <Typography variant="h5" style={{ marginBottom: '10px', color: theme.palette.type === "dark" ? "#FFF" : theme.palette.primary.main }}>{i18n.t("dashboard.assessments.npsResearch")}</Typography>
                </Grid2>
                {[
                  { label: i18n.t("dashboard.assessments.score"), value: counters.npsScore || 0, color: theme.palette.type === 'dark' ? "#FFF" : "#000" },
                  { label: i18n.t("dashboard.assessments.prosecutors"), value: counters.npsPromotersPerc || 0, color: "#2EA85A" },
                  { label: i18n.t("dashboard.assessments.neutral"), value: counters.npsPassivePerc || 0, color: "#F7EC2C" },
                  { label: i18n.t("dashboard.assessments.detractors"), value: counters.npsDetractorsPerc || 0, color: "#F73A2C" }
                ].map((data, index) => (
                  <Grid2 xs={12} md={6} lg={3} key={index}>
                    <Paper className={classes.paper} variant="outlined">
                      <Box className={classes.barContainer}>
                        <Typography className={classes.progressLabel}>{data.label}</Typography>
                        <LinearProgress
                          variant="determinate"
                          value={data.value}
                          className={classes.progressBar}
                          style={{
                            backgroundColor: data.color,
                          }}
                        />
                        <Typography className={classes.progressLabel}>{data.value}%</Typography>
                      </Box>
                    </Paper>
                  </Grid2>
                ))}

                {/* Informações de Atendimento */}
                <Grid2 xs={12} style={{ marginTop: '40px', paddingLeft: '4px' }}>
                  <Typography variant="h5" style={{ marginBottom: '10px', color: theme.palette.type === "dark" ? "#FFF" : theme.palette.primary.main }}>{i18n.t("dashboard.charts.perDay.title")}</Typography>
                </Grid2>
                {[
                  { label: i18n.t("dashboard.assessments.totalCalls"), value: counters.tickets || 0, icon: <CallIcon style={{ color: "#01BBAC", fontSize: "2.5rem", filter: "drop-shadow(0 0 6px rgba(1, 187, 172, 0.6))" }} /> },
                  { label: i18n.t("dashboard.assessments.callsWaitRating"), value: counters.waitRating || 0, icon: <HourglassEmptyIcon style={{ color: "#47606e", fontSize: "2.5rem", filter: "drop-shadow(0 0 6px rgba(71, 96, 110, 0.6))" }} /> },
                  { label: i18n.t("dashboard.assessments.callsWithoutRating"), value: counters.withoutRating || 0, icon: <ErrorOutlineIcon style={{ color: "#8a2c40", fontSize: "2.5rem", filter: "drop-shadow(0 0 6px rgba(138, 44, 64, 0.6))" }} /> },
                  { label: i18n.t("dashboard.assessments.ratedCalls"), value: counters.withRating || 0, icon: <CheckCircleOutlineIcon style={{ color: "#805753", fontSize: "2.5rem", filter: "drop-shadow(0 0 6px rgba(128, 87, 83, 0.6))" }} /> },
                ].map((attInfo, index) => (
                  <Grid2 xs={12} sm={6} md={3} key={index}>
                    <Paper className={classes.infoCard} variant="outlined" style={{ height: '100%' }}>
                      <Box display="flex" alignItems="center">
                        {attInfo.icon}
                        <Box ml={2}>
                          <Typography variant="h6">{attInfo.value}</Typography>
                          <Typography variant="body2">{attInfo.label}</Typography>
                        </Box>
                      </Box>
                    </Paper>
                  </Grid2>
                ))}

                {/* Índice de Avaliação */}
                <Grid2 xs={12} style={{ marginTop: '40px', paddingLeft: '4px', paddingRight: '4px' }}>
                  <Typography variant="h6" style={{ marginBottom: '15px', color: theme.palette.type === "dark" ? "#FFF" : theme.palette.primary.main }}>{i18n.t("dashboard.assessments.evaluationIndex")}</Typography>
                  <Grid2 container alignItems="center" spacing={2}>
                    <Grid2 xs={12} sm={2}>
                      <Paper className={classes.infoCard} style={{ textAlign: 'center', padding: '8px', backgroundColor: '#FFE3B3' }}>
                        <Typography variant="h6" style={{ color: '#F79009' }}>
                          {Number(counters.percRating / 100).toLocaleString(undefined, { style: 'percent' }) || "0%"}
                        </Typography>
                      </Paper>
                    </Grid2>
                    <Grid2 xs={12} sm={10}>
                      <LinearProgress
                        variant="determinate"
                        value={counters.percRating || 0}
                        className={classes.progressBar}
                        style={{ backgroundColor: "#e0e0e0", height: 10, borderRadius: 5 }}
                      />
                    </Grid2>
                  </Grid2>
                </Grid2>

                {/* Tabela de Atendentes */}
                <Grid2 xs={12} style={{ marginTop: '40px', paddingLeft: '4px' }}>
                  <Typography variant="h5" style={{ marginBottom: '10px', color: theme.palette.type === "dark" ? "#FFF" : theme.palette.primary.main }}>{i18n.t("dashboard.tabs.attendants")}</Typography>
                  <Paper className={classes.tableWrapper} variant="outlined">
                    <TableAttendantsStatus
                      attendants={attendants}
                      loading={loading}
                    />
                  </Paper>
                </Grid2>

                {/* Gráficos */}
                <Grid2 container spacing={3} xs={12}>
                  <Grid2 xs={12} md={6}>
                    <Paper className={classes.paper} variant="outlined" style={{ marginBottom: "16px" }}>
                      <ChatsUser />
                    </Paper>
                  </Grid2>
                  <Grid2 xs={12} md={6}>
                    <Paper className={classes.paper} variant="outlined">
                      <ChartsDate />
                    </Paper>
                  </Grid2>
                </Grid2>
                </Grid2>
              </Container>
            </div>
          </Paper>
        </MainContainer>
      )}
    </>
  );
};

export default Dashboard;
